import { useCallback, useEffect, useState } from 'react';
import { onMatchCombo } from './_shortcutRegistry';

/*
    🔥 CONTROL DE LA AYUDA DE ATAJOS

    Registra "?" (shift + /) para abrir la ventana.

    ⚠️ NO SE ABRE MIENTRAS ESCRIBÍS

    "?" es un carácter común: sin este filtro, escribir una pregunta en
    cualquier campo abriría la ayuda a mitad de la oración.

    ⚠️ TAMBIÉN PUEDE REGISTRAR LOS ATAJOS DE VERDAD

    Si a un ítem del catálogo le ponés onRun, este hook le engancha el
    listener. Así el mismo array es la ayuda Y el comportamiento: no
    hay forma de que la documentación quede desfasada del código.
*/

const IS_TYPING = () => {

    const EL = document.activeElement;

    if (!EL) return false;

    return EL.tagName === 'INPUT' || EL.tagName === 'TEXTAREA'
        || EL.tagName === 'SELECT' || EL.isContentEditable;
};

export const useShortcuts = ({
    shortcuts = [],
    hotkey = 'shift+/',
    isEnabled = true,
} = {}) => {

    const [useIsOpen, setIsOpen] = useState(false);

    const CB__open = useCallback(() => setIsOpen(true), []);
    const CB__close = useCallback(() => setIsOpen(false), []);
    const CB__toggle = useCallback(() => setIsOpen((prev) => !prev), []);

    useEffect(() => {

        if (!isEnabled) return;

        const onKeyDown = (event) => {

            // -------------------- 🎯 ABRIR LA AYUDA
            if (onMatchCombo(event, hotkey) && !IS_TYPING()) {
                event.preventDefault();
                setIsOpen((prev) => !prev);
                return;
            }

            if (event.key === 'Escape' && useIsOpen) {
                setIsOpen(false);
                return;
            }

            // -------------------- 🎯 ATAJOS CON ACCIÓN
            const HIT = shortcuts.find((s) => s.onRun && onMatchCombo(event, s.keys));

            if (!HIT) return;

            if (IS_TYPING() && !HIT.worksWhileTyping) return;

            event.preventDefault();
            HIT.onRun();
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);

    }, [shortcuts, hotkey, isEnabled, useIsOpen]);

    return { isOpen: useIsOpen, open: CB__open, close: CB__close, toggle: CB__toggle };
};
